import { useEffect, useState } from "react";
import { History as HistoryIcon } from "lucide-react";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "./ui/dialog";
import { Button } from "./ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";

export const WarehouseMovesDialog = ({ item }) => {
  const { t, fmt } = useI18n();
  const [open, setOpen] = useState(false);
  const [moves, setMoves] = useState(null);
  useEffect(() => { if (open) api.get(`/warehouse/${item.id}/moves`).then((r) => setMoves(r.data)); }, [open, item.id]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="ghost" data-testid={`wh-moves-${item.id}`}><HistoryIcon className="w-4 h-4" />{t("whMoves")}</Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="wh-moves-dialog">
        <DialogHeader>
          <DialogTitle>{t("whMoves")} · {item.name}</DialogTitle>
          <DialogDescription>{item.part_number ? <span className="font-mono" dir="ltr">#{item.part_number}</span> : null} · {t("whAvailable")}: <b>{item.quantity}</b></DialogDescription>
        </DialogHeader>
        <Table>
          <TableHeader><TableRow>{["date", "whMoveType", "quantity", "employeeName", "plate", "noteCol"].map((h) => <TableHead key={h} className="text-start">{t(h)}</TableHead>)}</TableRow></TableHeader>
          <TableBody>
            {moves && moves.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-500 py-8">{t("noData")}</TableCell></TableRow>}
            {(moves || []).map((m, i) => (
              <TableRow key={i} data-testid={`wh-move-${i}`}>
                <TableCell className="text-sm whitespace-nowrap">{fmt(m.date)}</TableCell>
                <TableCell>
                  <span data-testid={`wh-move-kind-${i}`} className={`text-xs font-bold rounded-full px-2 py-0.5 border ${m.kind === "in" ? "bg-emerald-100 text-emerald-800 border-emerald-300" : "bg-orange-100 text-orange-800 border-orange-300"}`}>
                    {m.kind === "in" ? t("whMoveIn") : t("whMoveOut")}
                  </span>
                </TableCell>
                <TableCell className="font-mono font-bold">{m.kind === "in" ? "+" : "−"}{m.quantity}</TableCell>
                <TableCell className="text-sm">{m.by_name}</TableCell>
                <TableCell>{m.plate ? <span className="plate text-xs">{m.plate}</span> : "-"}</TableCell>
                <TableCell className="text-sm">{m.note || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};
